import homepageDefaults from "../data/homepageContent.json";
import { InterestCategory } from "../types/interests";

export const interestCategories: InterestCategory[] = homepageDefaults.cards;
